import React from 'react';
import HeroVideo from './components/HeroVideo';
import HeroContent from './components/HeroContent';
import styles from './HeroSection.module.css';

const HeroSection = () => {
    return (
        <section className={styles.heroSection}>
            <div className={styles.heroBackground}>
                <div className={styles.heroOverlay}></div>
                <div className={styles.heroVideoContainer}>
                    <HeroVideo />
                </div>
            </div>
            <HeroContent />
        </section>
    );
};

export default HeroSection;